import { createContext } from 'react';

import type { GaugeChartSlotsConfig } from '../types/gauge-chart-config.js';

type GaugeChartLabelsContextProps = Omit<GaugeChartSlotsConfig, 'thresholds'>;

export const GaugeChartLabelsContext =
  createContext<GaugeChartLabelsContextProps>(
    {} as GaugeChartLabelsContextProps,
  );
